import { useContext } from "react";

import { QuickRankDesinationsContext, QuickRankDestinationsContextType } from "../../contexts/quickrank/destination";

export const useQuickRankDestinations = (): QuickRankDestinationsContextType => {
  const context = useContext(QuickRankDesinationsContext);
  if (!context) {
    throw new Error("useQuickRankDestinations must be used within a QuickRankContextProvider");
  }
  return context;
};
